// weight-management/monthly-touchpoint.tsx
import { makeid } from 'utils/helpers/makeid';

import { step3Config } from '../steps/step-3-consent';

import type { TFormItem } from '../../types';

export const weightMonthlyTouchpointConfig: TFormItem[] = [
  ...step3Config,
  {
    key: makeid(10),
    name: 'weightTrendReviewed',
    type: 'textarea',
    title: <p>Weight trend review since last touchpoint</p>,
    required: true,
  },
  {
    key: makeid(10),
    name: 'wellnessCheckIn',
    type: 'textarea',
    title: <p>General wellness check-in</p>,
    required: true,
  },
  {
    key: makeid(10),
    name: 'barriersConcerns',
    type: 'textarea',
    title: <p>Patient-reported barriers or concerns</p>,
    required: true,
  },
  {
    key: makeid(10),
    name: 'educationProvided',
    type: 'textarea',
    title: <p>Education provided</p>,
    required: true,
  },
];
